import React from 'react';
import { AsperaError } from '../../classes/AsperaError';
import { SubManager } from '../../classes/SubManager';
import { TableCell, Link } from '../Carbon';
/**
 * React Component
 *
 * The AsperaCellLink provides the column data for showing a link
 * This component does not use HandleClick. Instead uses linkOnClick on header
 *
 * @example
 * ```javascript
 * <AsperaCellLink name={name} onClick={onClick} />
 * ```
 */
class AsperaCellLink extends React.Component {
    constructor() {
        super(...arguments);
        this.row = undefined;
        this.subManager = new SubManager();
        this.handleClick = (event) => {
            const { header } = this.props;
            event.preventDefault();
            if (typeof header.linkOnClick === 'function')
                header.linkOnClick(this.row, event);
        };
    }
    componentDidMount() {
        const { forceUpdater } = this.props;
        this.subManager.setSubscription(forceUpdater.subscribe({
            next: data => {
                const { rowId } = this.props;
                if (data.id === rowId) {
                    this.row = data.row;
                    this.setState({});
                }
                else if (data.id === 'ASPERA_TABLE_UPDATE') {
                    const { row } = this.props;
                    this.row = row;
                    this.setState({});
                }
            },
            error: error => {
                new AsperaError('AsperaCellLink: Unable to subscribe to force updater for row updates', error);
            },
        }));
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        const { className, getTableText, header, row } = this.props;
        if (!this.row)
            this.row = row;
        const text = getTableText(this.row, header.key, header.formatter);
        return (React.createElement(TableCell, { className: `aspera-cell-link ${className ? className : ''}`, "data-auto": "table-cell-link" },
            React.createElement(Link, { className: "link-item", onClick: this.handleClick, "data-auto": `table-cell-link-item-${text}` }, text)));
    }
}
export default AsperaCellLink;
